module.exports = __webpack_public_path__ + "img/project_16.2aebea80.jpg";